import { not } from "./operators";

export const isIncludedIn = <T>(arr: T[]) => (v: T) => arr.includes(v);
export const isNotIncludedIn = <T>(arr: T[]) => not(isIncludedIn(arr));

// aliases
export const inArray = isIncludedIn;
export const notInArray = isNotIncludedIn;
